import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Chart, Plugin } from 'chart.js';
import { CompanyService } from 'src/app/services/company.service';

const beforeDrawPlugin: Plugin = {
  id: "beforeDrawPlugin",
  beforeDraw(chart) {
    const ctx = chart.ctx;
    const width = chart.width;
    const height = chart.height;
    const text = ""; // Customize this text

    ctx.restore();
    ctx.font = "bold 20px Arial";
    ctx.textBaseline = "middle";

    const textX = Math.round((width - ctx.measureText(text).width) / 2);
    const textY = height / 2;

    ctx.fillText(text, textX, textY);
    ctx.save();
  }
};

Chart.register(beforeDrawPlugin);


@Component({
  selector: 'app-valid-invalid-report-chart',
  templateUrl: './valid-invalid-report-chart.component.html',
  styleUrls: ['./valid-invalid-report-chart.component.scss']
})
export class ValidInvalidReportChartComponent implements OnInit, OnChanges {
  @Input() filterReq: any;
  @Input() isRefreshChart!: boolean;

  doughnutLabels1: any;
  doughnutData1: any;
  doughnutLabels2: any;
  doughnutData2: any;
  barLabels: any;
  barData: any;

  constructor(
    private companyService: CompanyService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    console.log("changes", changes);
    if (changes?.["isRefreshChart"]?.currentValue != changes?.["isRefreshChart"]?.previousValue) {
      this.getInvalidCertificatesStateWiseGraphData();
      this.getInvalidCertificatesFormWiseGraphData();
    }
  }

  ngOnInit(): void { }

  /**
   * The function `getInvalidCertificatesStateWiseGraphData` sends a POST request to retrieve state-wise
   * graph data for invalid certificates.
   */
  getInvalidCertificatesStateWiseGraphData() {
    this.companyService.getInvalidCertificatesStateWiseGraphData(this.filterReq).subscribe({
      next: (res: any) => {
        if (res && res?.length) {
          const labels = res?.map((el: any) => el.state);
          const data = res?.map((el: any) => el.percentage);
          this.doughnutLabels1 = labels;
          this.doughnutData1 = data;
        } else {
          this.doughnutLabels1 = [];
          this.doughnutData1 = [];
        }
      },
      error: (error) => {
        this.doughnutLabels1 = [];
        this.doughnutData1 = [];
      }
    });
  }

  /**
   * The function `getInvalidCertificatesFormWiseGraphData` sends a POST request to retrieve graph data
   * for invalid certificates based on specified criteria.
   */
  getInvalidCertificatesFormWiseGraphData() {
    this.companyService.getInvalidCertificatesFormWiseGraphData(this.filterReq).subscribe({
      next: (res: any) => {
        if (res && res?.length) {
          const labels = res?.map((el: any) => el.formName);
          const data = res?.map((el: any) => el.percentage);
          this.doughnutLabels2 = labels;
          this.doughnutData2 = data;
        } else {
          this.doughnutLabels2 = [];
          this.doughnutData2 = [];
        }
      },
      error: (error) => {
        this.doughnutLabels2 = [];
        this.doughnutData2 = [];
      }
    });
  }
}
